<template lang="html">
<div class="WangEdit">
<!--<div id="container" class="container editor">
		<div ref="toolbar" class="toolbar" id="toolbar-container" >
				 <button id="btnFull" class="fR full" ><img  src="/static/image/fullScreen.svg"></button>
		</div>

		<div ref="editor" class="text">
		</div>-->
			<div ref="container" class="container">
		<!--菜单栏-->
				<div class="posR toolbar-container toolbar bdSub boxR-top" ref="toolbar">
						<div class="editor-toolbar"></div>
						<button ref="btnFull" class="fR full" >
							<Icon :name="screenStatus=='def'?'fullScreen':'unFullScreen'" class="ico w1x h1x fSub"/>
							</button>
				</div>
				<!--编辑区域-->
				<div class="editor-text bdSub boxR-bottom" ref="editor">
				</div>
		 </div>
		<div class="fullCover"></div>
</div>
</template>

<script>
// import E from 'wangeditor'

export default {
  name: 'editoritem',
  data () {
    return {
      // uploadPath,
      editor: null,
      info_: null,
      screenStatus: 'def'
    }
  },
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: {
      type: String,
      default: ''
    },
    isClear: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    isClear (val) {
      // 触发清除文本域内容
      if (val) {
        this.editor.txt.clear()
        this.info_ = null
      }
    },
    value: function (value) {
      // if(this.editor){
      // 				this.editor.txt.text(this.value)
      // 			}
      // console.log(this.editor.txt.text().trim().length)
    }
    // value为编辑框输入的内容，这里我监听了一下值，当父组件调用得时候，如果给value赋值了，子组件将会显示父组件赋给的值 这里的监听会导致按空格的时候回到文档最后改为赋值
  },
  mounted () {
    this.seteditor()
  },
  methods: {
    editFuzhi (v) {
      this.editor.txt.text(v)
    },
    seteditor () {
      if (!window.wangEditor) {
        $.get('/static/js/wangEditor.min.js', this.editLoaded)
      } else {
        this.editLoaded()
      }
    },
    initThis () {
      // 创建富文本编辑器
      this.editor.create()
    },
    editLoaded: function () {
      var $this=this;
      var E = window.wangEditor
      this.editor = new E(this.$refs.toolbar, this.$refs.editor)
      this.editor.customConfig.uploadImgShowBase64 = false // base 64 存储图片
      this.editor.customConfig.uploadImgServer = '/store-s/uploadObject'// 配置服务器端地址
      this.editor.customConfig.uploadImgHeaders = {}// 自定义 header
      this.editor.customConfig.uploadFileName = 'file' // 后端接受上传文件的参数名
      this.editor.customConfig.uploadImgMaxSize = 2 * 1024 * 1024 // 将图片大小限制为 2M
      this.editor.customConfig.uploadImgMaxLength = 1 // 限制一次最多上传 1 张图片
      this.editor.customConfig.uploadImgTimeout = 3 * 60 * 1000 // 设置超时时间
      this.editor.customConfig.showLinkImg = false
      // 配置菜单
      this.editor.customConfig.menus = [
        'head', // 标题
        'bold', // 粗体
        'fontSize', // 字号
        'fontName', // 字体
        'italic', // 斜体
        'underline', // 下划线
        'strikeThrough', // 删除线
        'foreColor', // 文字颜色
        'backColor', // 背景颜色
        'link', // 插入链接
        'list', // 列表
        'justify', // 对齐方式
        'quote', // 引用
        // 'emoticon', // 表情
        'image', // 插入图片
        'undo', // 撤销
        'redo', // 重复
        'fullscreen' // 全屏
      ]

      this.editor.customConfig.uploadImgHooks = {
        before: function (xhr, editor, files) {
          if (files.length > 1) {
            return { prevent: true, msg: getLanguageStr('record8', '1次只能添加1张图片') }
          }
          let size = files[0].size / 1024 / 1024
          if (size > 2) {
            return { prevent: true, msg: i18n.t('fill3rd13', [2, '文件不超过2MB']) }
          }
        },
        fail: (xhr, editor, result) => {
          // 插入图片失败回调
        },
        success: (xhr, editor, result) => {
          // 图片上传成功回调
        },
        timeout: (xhr, editor) => {
          // 网络超时的回调
        },
        error: (xhr, editor) => {
          // 图片上传错误的回调
        },
        customInsert: (insertImg, result, editor) => {
          // 图片上传成功，插入图片的回调
          // result为上传图片成功的时候返回的数据，这里我打印了一下发现后台返回的是data：[{url:"路径的形式"},...]
          // insertImg()为插入图片的函数
          // 循环插入图片
          // for (let i = 0; i < 1; i++) {
          let url = result.url
          insertImg(url)
          // }
        }
      }
      this.editor.customConfig.onchange = (html) => {
        var str = html
        var s = html
        var n = (s.split('<img')).length - 1
        if (n > 25) {
          this.$notify(i18n.t('record2', [25, '不能超过25个图片']))
          return false
        } else {
          let t = this.editor.txt.text().length
          if (t < 2500) {
            this.info_ = html // 绑定当前逐渐地值
            this.$emit('change', this.info_, t, n) // 将内容同步到父组件中
          } else {
            this.info_ = html // 绑定当前逐渐地值
            this.$emit('change', this.info_, t, n)
            this.$notify(i18n.t('record1', [2500, '不能超过2500个字']))
            return false
          }
        }
      }

      var toolbar = this.$refs.toolbar
      var editorText = this.$refs.editor
      var cover = $(this.$el).find('.fullCover')[0]
      var container = this.$refs.container

      // 全屏事件
      function doFullScreen () {
        cover.style.display = 'block'
        editorText.style.height = ($(window).height() - 30) + 'px'
        cover.appendChild(toolbar)
        cover.appendChild(editorText)
        $this.screenStatus = 'fullScreen'
      }

      // 退出全屏事件
      function unDoFullScreen () {
        container.appendChild(toolbar)
        container.appendChild(editorText)
        editorText.style.height = '300px'
        cover.style.display = 'none'
        $this.screenStatus = 'def'
      }
      // 是否是全屏的标志
      var isFullScreen = false
      // 点击事件
      var btn = this.$refs.btnFull
      btn.addEventListener('click', function (e) {
        if (isFullScreen) {
          isFullScreen = false
          unDoFullScreen()
        } else {
          isFullScreen = true
          doFullScreen()
        }
      }, false)
      //  var E = window.wangEditor; var editor = new E('#editor'); editor.create(); E.fullscreen.init('#editor');
    }
  }
}
</script>

<style lang="css" scoped="scoped">
.editor {
  width: 100%;
  margin: 0 auto;
  position: relative;
  z-index: 0;
}
.text {
  border: 1px solid #ccc;
  min-height: 500px;
}
/*全屏*/
.container {
  width: 100%;
}
.toolbar-container:after {
  display: table;
  content: "";
  clear: both;
}
.editor-toolbar {
  float: left;
}
.editor-text {
  border-top: 0;
}
.fullCover {
  display: none;
  position: fixed;
  z-index: 10086;
  top: 0px;
  left: 15px;
  right: 15px;
  bottom: 0;
  background: #fff;
}
.toolbar-container .full {
  position: absolute;
  right: 1em;
  top: 0.2em;
}
.full img {
  width: 16px;
  height: 16px;
  display: inline-block;
}
</style>
<style lang="scss">
.WangEdit {
  .editor-text {
    > * {
      min-height: 10em;
    }
  }
  .w-e-text img {
  }
}
</style>



// WEBPACK FOOTER //
// src/view/application/maintenance/part/WangEditor.vue